<template>
  <res-dialog 
    :showDialog="showDialog"
    :maxWidth="600"
    :setWidth="600"
    :title="title"
    titleClass="resBlue darken-1 white--text"
    iconColor="white"
    saveButtonText="SAVE"
    :saveDisabled="isSaveDisabled"
    cancelButtonText="CANCEL"
    cancelButtonWidth="80"
    :defaultButtonAction="confirm"
    @save="confirm"
    @cancel="cancel" >
    <v-card-text>
      <div class="font-weight-500 text-center pb-4">
        {{ description }}
      </div>
      <div class="folder-input pt-5 pb-5">
        <res-text-field 
          v-model="documentName" 
          :filled="false" 
          :readonly="false" 
          :placeholder="placeholder" 
          :maxLength="255">
        </res-text-field>
      </div>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';
  import ResTextField from '@/components/base/ResTextField.vue';

  import IsNullOrWhitespaceMixin from '@/mixins/isNullOrWhitespace.js';

  export default {
    name: 'EditDocumentDialog',
    components: {
      ResDialog,
      ResTextField
    },
    mixins: [IsNullOrWhitespaceMixin],
    props: {
      showDialog: {
        type: Boolean
      },
      isFolder: {
        type: Boolean
      },
      previousName: {
        type: String
      }
    },
    data () {
      return {
        isSaving: false,
        documentName: ''
      }
    },
    methods: {
      cancel() {
        this.isSaving = true;
        this.$emit('cancel');
      },
      confirm() {
        this.isSaving = true;
        this.$emit('save', this.documentName);
      }
    },
    computed: {
      title() {
        return this.isFolder ? 
          "Edit Folder" : 
          "Edit Document";
      },
      description() {
        return this.isFolder ? 
          "Click inside the box below to rename the folder, then select SAVE." : 
          "Click inside the box below to rename the file, then select SAVE.";
      },
      placeholder() {
        return this.isFolder ? 
          "FOLDER NAME" : 
          "FILE NAME";
      },
      isSaveDisabled() {
        return this.isSaving || this.isNullOrWhitespace(this.documentName)
      }
    },
    mounted() {
      this.documentName = this.previousName;
    },
  }
</script>

